import '../polyfills';
import './portalVue';
import vuetify from './vuetify';
import VopsUI from './vopsui';

export default VopsUI;
export {
	vuetify
}